(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('prop-types')) :
  typeof define === 'function' && define.amd ? define(['react', 'prop-types'], factory) :
  (global = global || self, global.EllipsisLoader = factory(global.React, global.PropTypes));
}(this, (function (React, PropTypes) { 'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
  PropTypes = PropTypes && Object.prototype.hasOwnProperty.call(PropTypes, 'default') ? PropTypes['default'] : PropTypes;

  /** @format */

  /**
   * EllipsisLoader is a placeholder animation for indicating that data is Loading
   */
  var EllipsisLoader = function EllipsisLoader(_ref) {
    var baseClassName = _ref.baseClassName;
    return /*#__PURE__*/React.createElement("div", {
      className: baseClassName
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(baseClassName, "__ellipsis")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(baseClassName, "__ellipsis__dot")
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(baseClassName, "__ellipsis__dot")
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(baseClassName, "__ellipsis__dot")
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(baseClassName, "__ellipsis__dot")
    })));
  };

  EllipsisLoader.propTypes = {
    /** css class name for the base div of this component */
    baseClassName: PropTypes.string
  };
  EllipsisLoader.defaultProps = {
    baseClassName: 'loader'
  };

  return EllipsisLoader;

})));
